import * as React from 'react';
import axios from 'axios';
import { FormattedMessage } from "react-intl";
import moment from "moment-jalaali";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Source from '../../../Source';
import { useShowAlert } from "../../../warrper";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const amountStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 1.5,
  px: 2,
};


export default function FinancialSettlement({ open, setOpen, financial, setFinancial, financialData, setFinancialData ,records ,setRecords}) {
  
  const showAlert = useShowAlert();
  const handleClose = () => setOpen(false);
  
  // حالت برای مدیریت مبلغ تسویه
  const [settlementAmount, setSettlementAmount] = React.useState('');

  // بررسی حالت PUT
  const isPutMethod = financial._method === "put";
  
  const isFullyPaid = financialData.remainingAmount === 0;

  const handleAmountChange = (event) => {
    // اگر در حالت PUT هستیم، اجازه تغییر ندهیم
    if (isPutMethod) return;
    
    const value = event.target.value;
    // فقط اعداد مجاز هستند
    if (/^\d*$/.test(value)) {
      setSettlementAmount(value);
    }
  };

 const handleSave = () => {
    // اگر در حالت PUT هستیم، هیچ عملی انجام ندهیم
    if (isPutMethod) {
        showAlert({
            position: "top-end",
            icon: "warning",
            title: <FormattedMessage id="This action is not allowed in edit mode" />,
            showConfirmButton: false,
            timer: 1500,
        });
        return;
    }
    
    const amount = parseInt(settlementAmount) || 0;
    
    if (amount <= 0) {
        alert('لطفا مبلغ معتبری وارد کنید');
        return;
    }

    if (amount > financialData.remainingAmount) {
        alert('مبلغ تسویه نمی‌تواند بیشتر از مبلغ باقی‌مانده باشد');
        return;
    }

    // محاسبه مقادیر جدید
    const newPaidAmount = financialData.paidAmount + amount;
    const newRemainingAmount = financialData.totalAmount - newPaidAmount;

    // بروزرسانی داده‌های مالی
    const updatedFinancialData = {
        ...financialData,
        paidAmount: newPaidAmount,
        remainingAmount: newRemainingAmount
    };

    setFinancialData(updatedFinancialData);

    // ارسال به سرور
    const settlementData = {
        ...financial,
        amount: amount,
        surrendered:1,
        date: new Date().toISOString()
    };

    axios.post(Source.getAddress() + '/api/fsettlement', settlementData, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
    }).then((res) => {
        console.log(res);
        
        // Update records array with new settlement data
        const updatedRecords = records.map(record => {
            if (record.id === financial.f_id) { // Assuming financial object has the record id
                return {
                    ...record,
        surrendered:1,

                    settlement: {
                        id: res.data.id || 18, // Use response data or default
                        date: new Date().toISOString().replace('T', ' ').substring(0, 19),
                        amount: amount,
                        f_id: financial.id,
                        created_at: new Date().toISOString(),
                        updated_at: new Date().toISOString()
                    }
                };
            }
            return record;
        });

        setRecords(updatedRecords);
        
        showAlert({
            position: "top-end",
            icon: "success",
            title: <FormattedMessage id="Your record has been added!" />,
            showConfirmButton: false,
            timer: 1000,
        });
        
        handleClose();
        setSettlementAmount('');
        
    }).catch((err) => {
        console.log(err);
        alert('خطا در ذخیره اطلاعات');
    });
};

  const handleReset = () => {
    // اگر در حالت PUT هستیم، اجازه ریست ندهیم
    if (isPutMethod) return;
    
    setSettlementAmount('');
  };

  const formatCurrency = (amount) => {
    return amount?.toLocaleString() + " افغانی";
  };



   const date = (d) => {
      const date = new Date(d);
      let formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      let aa = ampm;
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      if (localStorage.getItem("date") === "Persian") {
        moment.locale("fa"); // تنظیم لوکال به فارسی
        aa = hours >= 12 ? "ب.ظ" : "ق.ظ";
        formattedDate = moment(d).format("jYYYY-jMM-jDD");
      } else {
        moment.locale("en"); // تنظیم لوکال به انگلیسی
      }
  
      return `${formattedDate} `;
    };

  return (
    <div>
      <Modal
        aria-labelledby="financial-settlement-modal"
        aria-describedby="financial-details"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {/* هدر */}
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <PaymentIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography id="financial-settlement-modal" variant="h5" component="h2" fontWeight="bold">
                {isPutMethod ? "مشاهده اطلاعات مالی" : "تسویه مالی"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {isPutMethod ? "فقط مشاهده - حالت ویرایش" : "مدیریت وضعیت مالی"}
              </Typography>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* هشدار حالت PUT */}
            {isPutMethod && (
              <Paper 
                elevation={2} 
                sx={{ 
                  mb: 3, 
                  p: 2, 
                  bgcolor: 'warning.light',
                  border: 1,
                  borderColor: 'warning.main'
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                  <PendingIcon color="warning" />
                  <Typography variant="body1" fontWeight="bold" color="warning.dark">
                    در حالت ویرایش - فقط مشاهده اطلاعات مجاز است
                  </Typography>
                </Stack>
              </Paper>
            )}

            {/* کارت وضعیت پرداخت */}
            <Paper 
              elevation={2} 
              sx={{ 
                mb: 3, 
                p: 2, 
                bgcolor: isFullyPaid ? 'success.light' : 'warning.light',
                border: 1,
                borderColor: isFullyPaid ? 'success.main' : 'warning.main'
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                {isFullyPaid ? (
                  <>
                    <CheckCircleIcon color="success" />
                    <Typography variant="body1" fontWeight="bold" color="success.dark">
                      تسویه کامل شده
                    </Typography>
                  </>
                ) : (
                  <>
                    <PendingIcon color="warning" />
                    <Typography variant="body1" fontWeight="bold" color="warning.dark">
                      در انتظار تسویه
                    </Typography>
                  </>
                )}
              </Stack>
            </Paper>

            {/* نمایش مبالغ */}
            <Stack spacing={2} sx={{ mb: 3 }}>
              {/* مبلغ کل */}
              <Paper elevation={1} sx={amountStyle}>
                <Typography variant="body1" color="text.primary" fontWeight="medium">
                  مبلغ کل:
                </Typography>
                <Chip 
                  label={formatCurrency(financialData.totalAmount)} 
                  color="primary"
                  variant="outlined"
                />
              </Paper>

              {/* مبلغ پرداختی */}
              <Paper elevation={1} sx={amountStyle}>
                <Typography variant="body1" color="success.main" fontWeight="medium">
                  مبلغ پرداختی:
                </Typography>
                <Chip 
                  label={formatCurrency(financialData.paidAmount)} 
                  color="success"
                  variant="filled"
                  icon={<CheckCircleIcon />}
                />
              </Paper>

              {/* مبلغ باقی‌مانده */}
              <Paper elevation={1} sx={{
                ...amountStyle,
                bgcolor: financialData.remainingAmount > 0 ? 'error.light' : 'success.light'
              }}>
                <Typography variant="body1" color="white" fontWeight="medium">
                  مبلغ باقی‌مانده:
                </Typography>
                <Chip 
                  label={formatCurrency(financialData.remainingAmount)} 
                  color={financialData.remainingAmount > 0 ? "error" : "success"}
                  variant="filled"
                />
              </Paper>
            </Stack>

            {/* فیلد مبلغ تسویه */}
            {!isPutMethod && (
              <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                <Typography variant="h6" component="h3" sx={{ mb: 2, textAlign: 'center' }}>
                  مبلغ تسویه
                </Typography>
                <TextField
                  fullWidth
                  label="مبلغ تسویه"
                  value={settlementAmount}
                  onChange={handleAmountChange}
                  placeholder="مبلغ را به افغانی وارد کنید"
                  disabled={isFullyPaid}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyIcon color="action" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant="body2" color="text.secondary">
                          افغانی
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  helperText={
                    financialData.remainingAmount > 0 
                      ? `حداکثر مبلغ قابل تسویه: ${formatCurrency(financialData.remainingAmount)}`
                      : 'تسویه کامل شده است'
                  }
                  error={parseInt(settlementAmount) > financialData.remainingAmount}
                />
              </Paper>
            )}

            {/* دکمه‌های عملیاتی */}
            <Stack direction="row" spacing={2}>
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={handleClose}
                color="inherit"
              >
                بستن
              </Button>
              
              {!isPutMethod && (
                <>
                  <Button 
                    variant="outlined" 
                    fullWidth 
                    onClick={handleReset}
                    color="secondary"
                    disabled={!settlementAmount}
                  >
                    پاک کردن
                  </Button>
                  <Button 
                    variant="contained" 
                    fullWidth 
                    onClick={handleSave}
                    disabled={!settlementAmount || parseInt(settlementAmount) <= 0 || parseInt(settlementAmount) > financialData.remainingAmount || isFullyPaid}
                    startIcon={<CheckCircleIcon />}
                  >
                    ذخیره تسویه
                  </Button>
                </>
              )}
            </Stack>

            {/* اطلاعات اضافی */}
            <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block', textAlign: 'center' }}>
              آخرین بروزرسانی: {date(financialData.date)}
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}